import StorageService from '../services/storage.service';
import { ListeningPackageType, PackageThumbnail, UserListeningPackagesResponse } from '../../common/services/package/package.model';
import LanguageChangeController from '../services/language-change.controller';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import NoAuthService from '../services/noauth.service';
import NoAuthPackagesService from '../services/noauth-packages.service';
import UserInfoService from '../services/user-info.service';

export default class NoAuthBuyController extends LanguageChangeController {
  private msisdn;
  private packet: PackageThumbnail;
  private valid = false;


  constructor(
    actionDispatcher: ActionDispatcherService,
    private noAuthService: NoAuthService,
    private noAuthPackagesService: NoAuthPackagesService,
    private storageService: StorageService,
    private userInfoService: UserInfoService
  ) { super(actionDispatcher); }


  public $onInit() {
    this.msisdn = this.storageService.getMsisdn();
    if (this.msisdn) {
      this.valid = true;
    }
    super.$onInit();

    if (angular.isUndefined(this.packet)) {
      return;
    }
  }

  protected resetPackageNames() {
    this.noAuthService.getPackageFromOfferId(this.packet.id).then(result => {
      this.packet = this.noAuthPackagesService.convertListeningPackage(result);
    });

    if (this.valid) {
      this.userInfoService.updatePackagesLanguage();
    }
  }

  public isPaycellPackage() {
    return this.packet.type === ListeningPackageType.CREDITCARD;
  }
}



// WEBPACK FOOTER //
// src/app/no-auth/buy/buy.controller.ts